import { render, staticRenderFns } from "./CalculadoraPrecioTratamientos.vue?vue&type=template&id=4dc523ee&scoped=true"
import script from "./CalculadoraPrecioTratamientos.vue?vue&type=script&lang=js"
export * from "./CalculadoraPrecioTratamientos.vue?vue&type=script&lang=js"
import style0 from "./CalculadoraPrecioTratamientos.vue?vue&type=style&index=0&id=4dc523ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc523ee",
  null
  
)

export default component.exports